module.exports = __webpack_public_path__ + "static/mastodon-950af32f02e37d7291db011cdba601cb.png";